import { restEventCommonParams } from '@/common/converter/const'
import { getOnInstantPlay } from '@/common/converter/utils/get-event-property'

export const convertEventOnInstantPlay = (elementList = []) => {
  // console.log('!!!!!!!!!!!!!!!!!!!!', elementList)
  const { type, contentId, contentType, method, bodyList, isRender } =
    getOnInstantPlay(elementList)

  if (!isRender) return undefined

  return {
    type,
    method,
    contentid: contentId,
    conenttype: contentType,
    bodylist: bodyList,
    ...restEventCommonParams
  }
}
